import * as React from 'react';
import { css } from 'aphrodite/no-important';
import { getSectionStyle, SectionStyleProps, SectionThemeProps } from '../pageLayouts/layout.utils';
import { useTheme } from '../../../theming/useTheme';
import { LARGE_SCREEN_SIZE } from '../../../mediaQueries.const';

const componentConfigThemeKey = 'section';

const getMaxWidth = (theme: SectionThemeProps, themeConfigurationPropKey: keyof SectionThemeProps | undefined) => {
  if (typeof themeConfigurationPropKey === 'string' && themeConfigurationPropKey in theme) {
    return theme[themeConfigurationPropKey];
  }

  return LARGE_SCREEN_SIZE;
};

export const Section: React.FunctionComponent<SectionStyleProps> = props => {
  const { children, themeConfigurationPropKey } = props;
  const theme = useTheme<SectionThemeProps>(componentConfigThemeKey);
  const sectionStyle = getSectionStyle(getMaxWidth(theme, themeConfigurationPropKey));

  return (
    <section className={css(sectionStyle)}>
      {children}
    </section>
  );
};
